import React from "react";
import { GatewayWithMachinesViewStateTypes } from "@src/types/gateways-with-machines";
import { useEditGatewayNameHook } from "./use-edit-gateway-name-hook";
import styles from "./edit-gateway-name.module.scss";
import { RenderIfUserHasPermission } from "../render-if-user-has-permission/render-if-user-has-permission";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import renameIcon from "@src/assets/svg/rename-blue-icon.svg";
import saveIcon from "@src/assets/svg/save-right-blue-icon.svg";
import closeIcon from "@src/assets/svg/close-orange-icon.svg";

interface EditGatewayNameProps {
  gateway: GatewayWithMachinesViewStateTypes;
}

const cssClassName = "edit-gateway-name";

export const EditGatewayName = ({ gateway }: EditGatewayNameProps) => {
  const {
    showInput,
    newGatewayName,
    texts,
    editGatewayName,
    onKeyDownFunc,
    updateNewGatewayName,
    saveGatewayName,
    cancelSaveGatewayName,
  } = useEditGatewayNameHook(gateway);

  return (
    <span className={styles[cssClassName]}>
      {!showInput && (
        <span className={styles[`${cssClassName}__item-name-wrapper`]}>
          <span className={styles[`${cssClassName}__item-name`]}>
            {newGatewayName || gateway.name}
          </span>
          <RenderIfUserHasPermission permission="manage-gateways">
            <span className={styles[`${cssClassName}__edit-text-button`]}>
              <IconButton
                fun={editGatewayName}
                icon={renameIcon}
                tooltip={texts.edit}
                variant="edit-save-close-icon"
              />
            </span>
          </RenderIfUserHasPermission>
        </span>
      )}
      {showInput && (
        <>
          <span className={styles[`${cssClassName}__item-name-input-wrapper`]}>
            <input
              type="text"
              value={newGatewayName}
              onClick={(event) => event.stopPropagation()}
              onChange={updateNewGatewayName}
              onKeyDown={onKeyDownFunc}
              className={styles[`${cssClassName}__item-name-input`]}
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
            />
          </span>
          <div className={styles[`${cssClassName}__buttons-wrapper`]}>
            <span className={styles[`${cssClassName}__save-text-button`]}>
              <IconButton
                fun={saveGatewayName}
                icon={saveIcon}
                tooltip={texts.save}
                variant="edit-save-close-icon"
              />
            </span>
            <span className={styles[`${cssClassName}__cancel-text-button`]}>
              <IconButton
                fun={cancelSaveGatewayName}
                icon={closeIcon}
                tooltip={texts.cancel}
                variant="edit-save-close-icon"
              />
            </span>
          </div>
        </>
      )}
    </span>
  );
};
